import {Component} from '@angular/core';

@Component({
  selector: 'faq-tenet',
  templateUrl: './faq-tenet.html'
})
export class FaqTenetCmp {
}
